//日本语
export default {
	voteAction: '投票',
	videoNavLabel: 'ビデオ',
	vipLevelLabel: 'VIPレベル',
	betOptions: { rose: 'バラ', lily: 'ユリ', fireworks: '花火', balloon: '風船' },
	Language: '日本語',
	registerPasswordLength: 'パスワードは6〜12文字で入力してください',
	system: {
		homePage: {
			title1: 'タイトル1',
			title2: 'タイトル2',
			description1: '過去7日間',
			description2: '過去6ヶ月',
		}
	},
	login:{
		subtitle:'今夜、あなただけの特別な出会いを始めましょう',
		register:'会員登録',
		usernamePls:'ユーザー名を入力してください',
		passwordPls:'パスワードを入力してください',
		toRegister:'アカウントはありませんか？今すぐ登録してください',
		doLogin:'ログイン',	  
	},
	register:{
		repasswordPls:'引き出しパスワードを入力してください',  
		codePls:'招待コードを入力してください',  
		register:'登録',
		xieyi:'利用規約に同意する',
		xieyiPls:'次の口座開設プロトコルを選択してください！',
	},
	mine:{
		xyfs:'信用スコア',
		ljjf:'累積積分',
		recharge:'ポイントチャージ',
		withdraw:'ポイント引き出し',
		money:'保有ポイント',
		infomation:'基本情報',
		moneylog:'ポイント使用履歴',
		withdrawrecord:'引き出し履歴',
		gamerecord:'ギフト記録',
		notice:'お知らせ',
		mymove:'視聴履歴',
		loginpwd:'ログインパスワード',
		paypwd:'パスワード使用',
		loginout:'ログアウト',
		paypwdhasseted:'現金引き出しパスワードが設定されています。変更が必要な場合は、カスタマーセンターにお問い合わせください',
		setbank:'入金カードを設定してください！',
		lorr:'ログイン/登録',
	},
	infomation:{
		username:'会員ID',
		name:'氏名',
		bankcard:'引き出し口座',
		phone:'携帯電話番号',
		recharge:'チャージ',
		amount:'保有ポイント',
		toserve:'カスタマーサービスにお問い合わせください',
		kfms:'オフラインでチャージしたい場合は、カスタマーサービスにお問い合わせください。一部の決済チャネルのチャージ金額は小数点1桁にランダムにチャージされますので、決済時に必ず確認してください',
	},
	withdraw:{
		title:'ポイント交換',
		log:'引き出し記録',
		method:'引き出し方法',
		avmoney:'利用可能ポイント',
		limit:'引き出し限度',
		submit:'ポイント引き出し申請',
		xiane:'単一限度額',
		numbers:'現金引き出し回数',
		time:'入金時間',
		zuidi:'最小',
		zuigao:'最大',
		numsmax:'1日最大現金引き出し',
		ci:'回',
		timedetail:'通常入金時間は5分程度で、最速で2分以内に入金されます',
		bank:'銀行カード',
		status1:'保留中',
		status2:'引き出し完了',
		status3:'引き出し不可',
		enterCorrectAmount: '正しい金額を入力してください',
		selectBankCard: '引き出し銀行カードを選択してください',
		enterPayPassword: '支払いパスワードを入力してください',
	},
	moneylog:{
		title:'ポイント詳細',
		type1:'チャージ',
		type2:'ボーナス',
		type3:'タスク',
		type4:'ボーナス',
		type5:'引き出し完了',
		type6:'引き出し失敗',
		rechargeNote: '（チャージ）',
	},
	setting:{
		loginpwdtitle:'ログインパスワード変更',
		oldpwd:'古いパスワードを入力してください',
		newpwd:'新しいパスワードを入力してください',
		renewpwd:'新しいパスワードを再入力してください',
		change:'変更',
		plseall:'入力したパスワードが一致しません！',
		pswwrong:'パスワード入力が2回一致しません',
		paypwdtitle:'資金パスワード設定',
		paypwd:'引き出し口座パスワードを入力してください',
		repaypwd:'パスワードをもう一度確認してください',
		title: '設定',
		basicInfo: '基本情報設定',
		loginPassword: 'ログインパスワード',
		fundPassword: '資金パスワード',
		logout: 'ログアウト',
		payPasswordSet: '引き出しパスワードが設定されています。変更が必要な場合は、カスタマーセンターにお問い合わせください',
		payPasswordNotSet: '設定されていません',
		payPasswordHasSet: '設定済み',
		confirm: '確認',
	},
	home:{
		gonggao:'究極のラグジュアリー体験を楽しむ',
		qgkf:'全国対応可能',
		hotlist:'人気おすすめリスト',
		hotgame:'タスクアクティベーション',
		gaoji:'プレミアム',
		smrz:'実地認証',
		videorz:'本人ビデオ認証',
		star:'評価',
		sg:'身長',
		xw:'サイズ',
		diqu:'サービス可能地域',
		apply:'デート申し込み',
		ssxz:'リアルタイム状況',
		joinvip:'が会員に加入しました',
	},
	video:{
		latest:'最新',
		title:'ビデオギャラリー',
		nums:'視聴数',
		bofangliang:'視聴数',
		hotlist:'人気おすすめ',
		plsrefisrt:'チャージしてからビデオをご覧ください！',
	    trialEnded: '試聴終了',
	    rechargeToWatch: 'チャージ後に無料で視聴できます',
	    goRecharge: '今すぐチャージ',
	},
	choose:{
		title:'最高の一夜',
		nav:'プロフィール',
		apply:'マッチング申請',
		jianjie:'マネージャープロフィール',
		move:'移動可能',
		click:'認証するにはクリック',
		detail:'詳細',
		videodetail:'ライブビデオ',
	},
	common:{
		refresh:'更新が成功しました',
		noallow:'機能が無効になっています！',
		disable:'無効',
		all:'すべて',
		nomore:'これ以上ありません',
		nodata:'データなし',
		submit:'送信',
		more:'マネージャーをもっと見る',
		pinglunnav:'レビュー',
		pingluntitle:'マネージャーレビュー',
		pldtitle:'レビュー詳細',
		minenav:'マイアカウント',
		homenav:'ホーム',
		addbank:'入金カード追加',
		setbank:'引き出し口座登録',
	},
	game:{
		expect:'期間',
		jieguo:'データ',
		da:'大',
		xiao:'小',
		dan:'奇数',
		shuang:'偶数',
		大:'大',
		小:'小',
		单:'奇数',
		双:'偶数',
		order:'タスク仕様書',
		clear:'注文クリア',
		submit:'送信確認',
		rewardSuccess:'チップの送信に成功しました',
		kjcc:'当選成功、期間:',
		lxgly:'このタスクは管理者にお問い合わせください',
		plsmoney:'金額を入力してください！',
		plsnum:'番号を選択してください！',
		moneynote:'残高不足です。カスタマーサービスに連絡してチャージしてください！',
		lefttime:'残り時間',
		lunci:'期間',
		workRecord: 'タスク記録',
		day: '日',
		period: '期間',
		allWork: 'すべてのタスク',
		reset: 'リセット',
		confirm: '確認',
		bonusPoints: 'ボーナスポイント',
		missionMoney: 'タスク金額明細',
		missionResult: 'タスク結果',
		points: 'ポイント',
		workPoints: 'タスクポイント',
		giftCompleted: 'ギフト完了',
		orderTime: '注文時間:',
		detail: '詳細',
		content: '内容',
		amount: '金額',
		result: '結果',
		time: '時間',
		win: '勝利',
		missionFailed: 'タスク失敗',
	},
	kefu:{
		title:'オンラインカスタマーサービス',
		lianxi:'連絡',
		content:'24時間365日対応',
		defaultName: 'オンラインサービス',
	},
	setname:{
		title:'実名修正',
		xingming:'名前',
		tips:'アカウントのセキュリティのため、実名はバインドされた銀行カード名と一致しなければなりません',
		xmpls:'実名を入力してください',
		save:'保存',
		notreset:'設定を繰り返さないでください！',
		plsentername:'名前を入力してください！',
	},
	// 追加された言語キー
	withdrawCenter: '引き出しセンター',
	withdrawRecord: '引き出し記録',
	withdrawAmount: '引き出し金額',
	allMoney: 'すべて',
	singleLimit: '単一限度',
	lowest: '最低',
	highest: '最高',
	withdrawTimes: '引き出し回数',
	maxDailyWithdraw: '1日最大引き出し',
	times: '回',
	arrivalTime: '入金時間',
	limitDescription: '限度説明',
	balance: '残高',
	withdrawNow: '今すぐ引き出し',
	enterCorrectAmount: '正しい金額を入力してください',
	personalReport: '個人レポート',
	profitAmount: '利益金額',
	profitFormula: '利益計算式: 当選金額 - タスク金額',
	taskAmount: 'タスク金額',
	accountOffline: 'アカウントオフライン',
	loginRegister: 'ログイン/登録',
	loginForMore: 'ログインしてより多くのサービスをお楽しみください！',
	// コメント関連
	author: '著者:',
	notification: '通知',
	// 設定関連
	changePhone: '携帯電話番号変更',
	save: '保存',
	existingPhone: '既存の携帯電話番号',
	newPhone: '新しい携帯電話番号',
	// 銀行関連
	withdrawAccountRegister: '引き出し口座登録',
	selectBankCard: '銀行カードを選択してください',
	accountNumber: '口座番号',
	enterBankCardNumber: '銀行カード番号を入力してください',
	// 通知関連
	systemNotice: 'システム通知',
	// 視聴記録関連
	myMovie: '私の映画',
	completeTaskForMore: 'より多くの映画チケットを入手するためにタスクを完了してください',
	movieTicket: '映画チケット:',
	watchList: '視聴リスト',
	noDataYet: 'まだデータがありません',
	// その他
	setNameFirst: '引き出し口座をリンクする前に名前を設定してください！',
	setPasswordFirst: '銀行カードをバインドする前に引き出しパスワードを設定してください！',
	// 銀行関連
	accountHolder: '口座名義人',
	enterRealName: '実名を入力してください',
	withdrawPassword: '引き出しパスワード',
	registerWithdrawPassword: '引き出しパスワードを登録してください',
	bankCard: '銀行カード',
	// ゲーム関連
	orderContentLabel: '注文内容:',
	all: 'すべて',
	bonusPointsLabel: 'ボーナスポイント',
	waitingResultLabel: '結果待ち',
	missionMoneyDetails: 'ミッション金額明細',
	points: 'ポイント',
	// 宝くじ関連
	switch: 'スイッチ',
	currentSelection: '現在の選択:',
	quantity: '数量:',
	total: '合計',
	ticketAmount: 'チケット数',
	availablePoints: '利用可能ポイント',
	verify: '認証',
	// プロフィール関連
	possible: '可能',
	thumb: '親指',
	privacyPolicy: 'プライバシーポリシー',
	romanticDescription: '私たちのロマンチックサービスは、会員の個人情報を保護するため、実名認証サービスの完了または認証済み会員の推薦を通じてのみ登録が可能です。',
	// ホーム関連
	person1: '夏雨',
	person2: '敏雪',
	lishijl: '履歴記録',
	cryptoWithdraw: { title:'暗号資産の出金',record:'出金履歴',assetTitle:'デジタル資産の出金',assetSubtitle:'暗号資産ウォレットへ安全に送金',selectCoin:'通貨を選択',selectNetwork:'ネットワークを選択',walletAddress:'受取ウォレットアドレス',walletPlaceholder:'ウォレットアドレスを入力',addressTip:'{network} 対応アドレスか確認してください。送金は取り消せません。',amount:'出金額',all:'全額',availableBalance:'利用可能残高',network:'出金ネットワーク',fee:'予想手数料',arrival:'受取予定額',confirm:'出金を確認',submitting:'送信中...',safetyInfo:'出金の安全案内',safetyCaption:'支払パスワードと暗号化で資金を保護します',verification:'セキュリティ認証',passwordPrompt:'確認のため支払パスワードを入力してください',payPassword:'支払パスワード',passwordPlaceholder:'支払パスワードを入力',cancel:'キャンセル',rulesTitle:'暗号資産出金ガイド',rule1:'ウォレットが選択した通貨とネットワークに対応しているか確認してください。',rule2:'出金申請はセキュリティ審査の対象です。',rule3:'着金時間はブロックチェーンの状況により異なります。',rule4:'完了した送金は取り消せません。',enterAddress:'受取アドレスを入力してください',invalidAddress:'アドレスが選択したネットワークと一致しません',invalidAmount:'出金額は手数料を超える必要があります',insufficientBalance:'出金額が残高を超えています',enterPassword:'支払パスワードを入力してください',passwordError:'支払パスワードが正しくありません',success:'出金申請を送信しました',failed:'出金に失敗しました' },
	cryptoAddress:{bind:'アドレス登録',title:'出金アドレス登録',selectCoin:'通貨を選択',selectNetwork:'ネットワークを選択',address:'ウォレットアドレス',placeholder:'ウォレットアドレスを入力',tip:'選択した通貨とネットワークに対応していることを確認してください。',save:'アドレスを保存',modify:'アドレスを変更',saving:'保存中...',invalid:'無効なウォレットアドレス',success:'アドレスを保存しました',scanSuccess:'QRコードを認識しました',scanFail:'有効なウォレットアドレスが見つかりません',verify:'取引パスワード確認',password:'取引パスワード',passwordPlaceholder:'取引パスワードを入力',confirm:'変更を確認',cancel:'キャンセル',passwordRequired:'取引パスワードを入力してください'},
};
